import React from 'react';
export function PhoneOnlyProof() {
  return <section className="bg-warm-mid py-16 md:py-20 px-4" data-id="element-188">
      <div className="max-w-3xl mx-auto text-center" data-id="element-189">
        {/* Heading */}
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-warm-hero mb-8 leading-tight" data-id="element-190">
          No professional camera{' '}
          <span className="italic text-soft-gold" data-id="element-191">required</span>
        </h2>

        {/* Image */}
        <div className="mb-8 rounded-2xl overflow-hidden shadow-xl max-w-2xl mx-auto" data-id="element-192">
          <img src="https://images.unsplash.com/photo-1596492784531-6e6eb5ea9993?w=900&h=600&fit=crop&crop=center" alt="Smartphone displaying a beautiful dog photo with the actual dog in the background, warm natural light" className="w-full h-auto object-cover" data-id="element-193" />
        </div>

        {/* Text below */}
        <p className="font-sans text-lg md:text-xl text-gray-800 max-w-2xl mx-auto leading-relaxed" data-id="element-194">
          This was designed specifically for dog owners using their phone — not
          for professional photographers with expensive gear.
        </p>
      </div>
    </section>;
}